import React, { useEffect } from "react";
import styled from "styled-components";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Container } from "@mui/material";
import config from "../utils/config";

const IFrame = styled.iframe`
  width: 100%;
  height: 100%;
  min-height: inherit;
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  pointer-events: auto;
`;

const AhuType = () => {
  const { ahuType } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Map AHU types to their corresponding HTML files
  const ahuTypeMap = {
    energy: `${config.interactiveUrl}/prime/indexEnergyPrime.html`,
    compact: `${config.interactiveUrl}/prime/indexCompactPrime.html`, // Will be used later for compact
    aqua: `${config.interactiveUrl}/prime/indexAquaPrime.html`
  };

  // Get the HTML file for the current AHU type
  const htmlFile = ahuTypeMap[ahuType];

  const getAhuTypeTitle = (type) => {
    switch (type) {
      case "energy":
        return t("framelessSelect.energyAhuTitle");
      case "compact":
        return t("framelessSelect.compactAhuTitle");
      default:
        return t("framelessSelect.ahuSelection");
    }
  };

  // Listen for messages from the iframe
  useEffect(() => {
    const handleMessage = (event) => {
      // Optional: Add origin validation for security
      // if (event.origin !== 'https://interactive.frameless-select.com') return;

      if (event.data && event.data.type === "NAVIGATE") {
        const { path } = event.data;
        navigate(path);
      }
    };

    window.addEventListener("message", handleMessage);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [navigate]);

  return (
    <Container
      sx={{
        py: 2,
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
      maxWidth="true"
    >
      {/* Iframe Section */}
      <Box
        sx={{
          flex: 1,
          position: "relative",
          minHeight: "calc(100vh - 185px)",
        }}
      >
        {htmlFile && (
          <IFrame
            src={`${htmlFile}`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation"
            title={`${getAhuTypeTitle(ahuType)} - Frameless Select`}
            loading="lazy"
          />
        )}
      </Box>
    </Container>
  );
};

export default AhuType;
